import request from "../../../../helpers/request"
import { IGetConfigPtMonAnalogico } from "./types"

export const getConfigPtMonAnalogico = async ({ adrModulo, idCentral, idEntrada }: IGetConfigPtMonAnalogico) => {
  const url = `${process.env.REACT_APP_API}/MonAnalogico/GetByEntrada?idCentral=${idCentral}&adrModulo=${adrModulo}&idEntrada=${idEntrada}`
  const result = await request({ url })
  return result.data
}